/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmFunkcniMistoKonfiguracniSkupina extends GContentBase<SeznamAdmFunkcniMistoKonfiguracniSkupinaObj> {
        private seznamObj: SeznamAdmFunkcniMistoKonfiguracniSkupinaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmFunkcniMistoKonfiguracniSkupinaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmFunkcniMistoKonfiguracniSkupinaNew",
                contentCaption: "jres:33000369", //RC 33000369 : Funk�n� m�sta p�i�azen� konf. skupin�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_usr_txt}<br />{ixs_fun_txt}"
                },
                gridSettings: {
                    columnOrder: "ixs_usr_txt,ixs_fun_txt,dat_zmena,zmenu_provedl,ixs_lpc"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmFunkcniMistoKonfiguracniSkupinaObj extends GAdmSeznamBase {
        private ixs_usr: string;
        private ixs_fun: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmFunkcniMistoKonfiguracniSkupina", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }];
            const inputParams = {
                ID: "DetailAdmFunkcniMistoKonfiguracniSkupina",
                newRecord: isNew,
                ixs_usr: isNew == true ? ((this.ixs_usr) ? this.ixs_usr : null) : data.ixs_usr,
                ixs_fun: isNew == true ? ((this.ixs_fun) ? this.ixs_fun : null) : data.ixs_fun,
                lic: isNew == true ? null : data.lic
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: true,
                disabled: (this.ixs_fun) ? true : false
            }).addRow("jres:29932054").addField("gselectbox", Gordic.Prefabs.Select.ginsusr(), {
                name: "ixs_usr",
                model: "model.ixs_usr=value.ixs_usr",
                dropdown: true,
                disabled: (this.ixs_usr) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_fun)
                hardFilter["ixs_fun"] = this.ixs_fun
            if (this.ixs_usr)
                hardFilter["ixs_usr"] = this.ixs_usr
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmFunkcniMistoKonfiguracniSkupina.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.ixs_fun, data.ixs_usr),
                nazev: ""
            }
        }
    }
}